import {
  BarChart3,
  BrainCircuit,
  HeartHandshake,
  UserRound,
  Users,
  UserPlus,
} from "lucide-react";

import { MarketingContainer } from "./ui/MarketingContainer";

const features = [
  {
    title: "Member Management",
    description:
      "Keep every member and household organized with complete profiles and relationships.",
    icon: UserRound,
  },
  {
    title: "Attendance & Check-In",
    description:
      "Capture attendance quickly and monitor long-term engagement trends.",
    icon: Users,
  },
  {
    title: "Visitor Follow-Up",
    description:
      "Track first-time guests and ensure every visitor receives intentional follow-up.",
    icon: UserPlus,
  },
  {
    title: "Care Queue",
    description:
      "Automatically identify members who may need pastoral care before they quietly drift away.",
    icon: HeartHandshake,
  },
  {
    title: "Executive Reporting",
    description:
      "Understand ministry health with dashboards and actionable reports.",
    icon: BarChart3,
  },
  {
    title: "AI Ministry Intelligence",
    description:
      "Receive proactive recommendations that help ministry leaders know where to focus next.",
    icon: BrainCircuit,
    comingSoon: true,
  },
];

export function FeaturesSection() {
  return (
    <section
      id="features"
      className="border-b border-white/5 py-24"
    >
      <MarketingContainer>
        <div className="mx-auto max-w-3xl text-center">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-indigo-300">
            Platform Features
          </p>

          <h2 className="mt-4 text-4xl font-black tracking-tight text-white sm:text-5xl">
            Everything your ministry needs.
            <br />
            One intelligent platform.
          </h2>

          <p className="mt-6 text-lg leading-8 text-slate-400">
            MinistryIQ helps pastors spend less time managing
            spreadsheets and more time caring for people.
          </p>
        </div>

        <div className="mt-16 grid gap-6 md:grid-cols-2 xl:grid-cols-3">
          {features.map((feature) => {
            const Icon = feature.icon;

            return (
              <div
                key={feature.title}
                className="group rounded-3xl border border-white/10 bg-slate-900/70 p-8 transition duration-300 hover:-translate-y-1 hover:border-indigo-400/30"
              >
                <div className="flex items-center justify-between">
                  <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-indigo-500/10 text-indigo-300">
                    <Icon className="h-6 w-6" />
                  </div>

                  {feature.comingSoon && (
                    <span className="rounded-full bg-indigo-500/10 px-3 py-1 text-xs font-semibold text-indigo-300">
                      Coming Soon
                    </span>
                  )}
                </div>

                <h3 className="mt-8 text-xl font-bold text-white">
                  {feature.title}
                </h3>

                <p className="mt-3 leading-7 text-slate-400">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </MarketingContainer>
    </section>
  );
}